import React, { useEffect } from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Title from "../components/title"
import Seo from "../components/seo"

import MagazineMainNav from "../components/magazine-main-nav"
import PostListItem from "../components/post-list-item"
import PostListItemFullWidth from "../components/post-list-item-full-width"

const CategoryTemplate = ({ data: { category, allPosts }, location }) => {
  const cat = category.edges[0].node
  const posts = allPosts.edges
  const firstPost = posts[0] ? posts[0].node : false
  const postsExceptFirst = [...posts].splice(1)

  let count = 0

  const postsLeft = postsExceptFirst.map((post) => {
    count++
    let triple = false

    if ((count % 3) === 0) {
      triple = true
    }
    return (
      <li className={ triple ? 'full-width' : ''}>
        { 
          triple ? (
            <PostListItemFullWidth post={post.node} location={location} />
          ) : (
            <PostListItem post={post.node} location={location} />
          )
        }
      </li>
    )
  })

  useEffect(() => {
  })

  return (
    <Layout showMagazineMainNav={true}>
      <Seo title={cat.nameJA} description={cat.description} />
      <section id="content-header">
        <Title categoryTitle={cat.nameEN} />
        <MagazineMainNav />
      </section>
      <section id="pickup-article">
        <PostListItemFullWidth post={firstPost} location={location} />
      </section>
      <div className="wrapper">
        <section className="article-list category-list">
          <ul>
            {postsLeft}
          </ul>
        </section>
      </div>
    </Layout>
  )
}

export default CategoryTemplate

export const pageQuery = graphql`
  query PostJsonByCategoryId(
    $categoryId: Int!
  ) {
    allPosts: allPostsJson(filter: {categoryId: {eq: $categoryId}}, sort: {fields: postedAt, order: DESC}) {
      edges {
        node {
          id
          title
          postId
          postedAt
          categoryId
          thumbnailSquare {
            src {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          thumbnailLandscape {
            src {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
    category: allCategoryJson(filter: {categoryId: {eq: $categoryId}}) {
      edges {
        node {
          id
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
